import { useState, useEffect } from 'react';
import { Link, useHistory } from 'react-router-dom';
import Api from '../api/api';
import Modal from 'react-bootstrap/Modal';
import Enums from '../../utilities/enum';
import Loader from '../shared/loader';
import UploadFiles from '../shared/file-uploader';
import stringHelpers from '../../utilities/stringHelpers';
import { useParams } from 'react-router-dom/cjs/react-router-dom.min';
import { ErrorModal } from '../../utilities/errorModal'
import formUtilities from '../../utilities/formUtilities';
import { TransferLiabilityContactDetails } from './transferLiabilityContactDetails';
import { toDateString, toInputFieldDateString } from '../../utilities/dateUtilities';
import arrayUtilities from '../../utilities/arrayUtilities';
import { countries } from '../../utilities/constants';
import { SearchSelect } from '../shared/searchSelect';

function TransferLiability(props) {
    const {transferOfLiabilityId} = useParams()
    const [transfer, setTransfer] = useState(null);
    const [isNew, setIsNew] = useState(false);
    const [breachId, setBreachId] = useState(props.match.params.breachId);
    const [contactTypes, setContactTypes] = useState(null);
    const [breach, setBreach] = useState(null);
    const [errorMessage, setErrorMessage] = useState(null);
    const [canTransfer, setCanTransfer] = useState(false);
    const history = useHistory();
    const [newContactMode, setNewContactMode] = useState(false)
    const [contacts, setContacts] = useState(null)
    const [selectedContact, setSelectedContact] = useState(null)
    const [designationLiable, setDesignationLiable] = useState(null);
    const [titleLiable, setTitleLiable] = useState("");
    const [firstNameLiable, setFirstNameLiable] = useState("");
    const [lastNameLiable, setLastNameLiable] = useState("");
    const [companyNameLiable, setCompanyNameLiable] = useState("");
    const [address1Liable, setAddress1Liable] = useState("");
    const [address2Liable, setAddress2Liable] = useState("");
    const [address3Liable, setAddress3Liable] = useState("");
    const [cityLiable, setCityLiable] = useState("");
    const [postcodeLiable, setPostcodeLiable] = useState("");
    const [countryLiable, setCountryLiable] = useState("United Kingdom");
    const [contactNumberLiable, setContactNumberLiable] = useState("");
    const [emailAddressLiable, setEmailAddressLiable] = useState("");

    const [title, setTitle] = useState("");
    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [companyName, setCompanyName] = useState("");
    const [address1, setAddress1] = useState("");
    const [address2, setAddress2] = useState("");
    const [address3, setAddress3] = useState("");
    const [city, setCity] = useState("");
    const [postcode, setPostcode] = useState("");
    const [country, setCountry] = useState("United Kingdom");
    const [contactNumber, setContactNumber] = useState("");
    const [emailAddress, setEmailAddress] = useState("");

    const [fileNotifier, setFileNotifier] = useState(null);
    const [fileLiable, setFileLiable] = useState(null);
    const [response, setResponse] = useState(null)

    const [showNotifier, setShowNotifier] = useState(false);
    const [showLiable, setShowLiable] = useState(false);
    const [dateReceived, setDateReceived] = useState("");

    const handleCloseNotifier = () => setShowNotifier(false);
    const handleShowNotifier = () => setShowNotifier(true);
    const handleCloseLiable = () => setShowLiable(false);
    const handleShowLiable = () => setShowLiable(true);

    const getTransferOfLiability = function () {
        Api.getTransferOfLiability(
            (data) => setTransfer(data),
            (error) => {
                console.log(error)
            },
            breachId,
            transferOfLiabilityId,
            props.organisationId,
            props.token
        )
    };

    const decline = function () {
        Api.declineTransferLiability(
            data => {
                if (data.isError) {
                    setErrorMessage(data.errorMessage)
                } else history.push(backUrl)
            },
            error => {
                setErrorMessage(error.errorMessage)
                console.log(error)
            },
            breachId, transfer.id,
            response,
            props.organisationId,
            props.token
        )
    };

    const accept = function () {
        Api.acceptTransferLiability(
            data => {
                if (data.isError) {
                    setErrorMessage(data.errorMessage)
                } else history.push(backUrl)
            },
            error => {
                setErrorMessage(error.errorMessage)
                console.log(error)
            },
            breachId, transfer.id,
            response,
            props.organisationId,
            props.token
        )
    };

    const getBreach = function () {
        Api.getBreach(
            (data) => setBreach(data),
            (error) => console.log(error),
            breachId,
            props.organisationId,
            props.token
        )
    };

    const getContacts = function () {
        Api.getAllContacts(
            (data) => {
                if (arrayUtilities.isNullOrEmpty(data)) {
                    setNewContactMode(true)
                }
                else {
                    setContacts(data)
                }
                
            },
            (error) => { console.log(error) },
            breachId, props.organisationId, props.token
        )
    };

    const handleContactSelection = (contactId) => {
        setNewContactMode(false)
        setSelectedContact(contactId)
    }

    const resetContactFields = () => {
        setTitle("")
        setFirstName("")
        setLastName("")
        setCompanyName("")
        setAddress1("")
        setAddress2("")
        setAddress3("")
        setCity("")
        setPostcode("")
        setCountry("United Kingdom")
        setContactNumber("")
        setEmailAddress("")
    }

    const submit = function () {
        if (canTransfer) {
            let notifier = { firstName: null, lastName: null, companyName: null, addressLine1: null, addressLine2: null, addressLine3: null, townOrCity: null, postCode: null, country: null, mobilePhoneNumber: null, emailAddress: null, contactType: null, contactId: null };
            if (stringHelpers.isNullOrEmpty(selectedContact)) {
                notifier = { ...notifier, firstName, lastName, companyName, addressLine1: address1, addressLine2: address2, addressLine3: address3, townOrCity: city, postCode: postcode, country, mobilePhoneNumber: contactNumber, emailAddress, contactType: 0 };
            } else {
                notifier = { ...notifier, contactId: selectedContact };
            }
            if (fileNotifier !== null) {
                notifier.attachmentId = fileNotifier.id
            }
            var liabilityParty = new Object();
            liabilityParty.firstName = firstNameLiable;
            liabilityParty.lastName = lastNameLiable;
            liabilityParty.companyName = companyNameLiable;
            liabilityParty.addressLine1 = address1Liable;
            liabilityParty.addressLine2 = address2Liable;
            liabilityParty.addressLine3 = address3Liable;
            liabilityParty.townOrCity = cityLiable;
            liabilityParty.postCode = postcodeLiable;
            liabilityParty.country = countryLiable;
            liabilityParty.mobilePhoneNumber = contactNumberLiable;
            liabilityParty.emailAddress = emailAddressLiable;
            if (fileLiable !== null) {
                liabilityParty.attachmentId = fileLiable.id;
            }
            liabilityParty.contactType = designationLiable;

            Api.addTransferLiability(
                (data) => setTransfer(data),
                (error) => {
                    setErrorMessage(error.errorMessage)
                    console.log(error)
                },
                notifier, liabilityParty, !stringHelpers.isNullOrEmpty(dateReceived) ? dateReceived : null, breachId,
                props.organisationId, props.token
            );
        }
    };

    const setTypes = function (types) {
        var tempTypes = [];
        var i = 0;
        while (true) {
            if (types[i] === undefined) {
                break;
            } else {
                tempTypes.push(types[i])
                i++;
            }
        }
        setContactTypes(tempTypes);
    };

    useEffect(() => {
        const notifierValid = !stringHelpers.isNullOrEmpty(selectedContact) ||
            (((!stringHelpers.isNullOrEmpty(firstName) && !stringHelpers.isNullOrEmpty(lastName)) || !stringHelpers.isNullOrEmpty(companyName)) &&
            !stringHelpers.isNullOrEmpty(address1) && !stringHelpers.isNullOrEmpty(city) &&
            !stringHelpers.isNullOrEmpty(postcode) && !stringHelpers.isNullOrEmpty(emailAddress));
        const liabilityPartyValid =
            ((!stringHelpers.isNullOrEmpty(firstNameLiable) && !stringHelpers.isNullOrEmpty(lastNameLiable)) || !stringHelpers.isNullOrEmpty(companyNameLiable)) &&
            !stringHelpers.isNullOrEmpty(address1Liable) && !stringHelpers.isNullOrEmpty(cityLiable) &&
            !stringHelpers.isNullOrEmpty(postcodeLiable) && !stringHelpers.isNullOrEmpty(emailAddressLiable);
        setCanTransfer(notifierValid && liabilityPartyValid);
    }, [selectedContact, firstName, lastName, companyName, address1, city, postcode, emailAddress, firstNameLiable, lastNameLiable, companyNameLiable, address1Liable, cityLiable, postcodeLiable, emailAddressLiable, designationLiable]);

    useEffect(() => {
        if (transfer === null) {
            setIsNew(true);
        } else {
            setIsNew(false);
        }
    }, [transfer]);
    
    useEffect(() => {
        if (breachId !== undefined) {
            getBreach();
            getContacts()
            if (!stringHelpers.isNullOrEmpty(transferOfLiabilityId)) {
                getTransferOfLiability();
            }
            setTypes(Enums.ContactTypes);
        }
    }, []);

    var backUrl = '/organisation/' + props.organisationId + '/breach/' + breachId;

    return (
        <>
            {transfer === null && !isNew && <Loader />}
            {transfer !== null && breach !== null && <>
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-12">
                            <div className="card mb-3">
                                <div className="card-header">
                                    <div className="row align-items-center">
                                        <div className="col">
                                            <h5 className="mb-0">Transfer of Liability - {breach.referenceNumber}</h5>
                                        </div>
                                        <Link className="btn btn-falcon-default btn-sm mr-3 py-1" type="button" to={backUrl}><i className="fas fa-reply"></i> Back</Link>
                                    </div>
                                </div>
                                <div className="card-body bg-light border-top transfer-container">
                                    <div className="row">
                                        <div className="col-md-6 col-12">
                                            <h5 className="text-center mb-3">
                                                Notifier
                                            </h5>
                                            <TransferLiabilityContactDetails contact={transfer.liabilityNotifierContact} />
                                        </div>
                                        <div className="col-md-6 col-12">
                                            <h5 className="text-center mb-3">
                                                Liable Party
                                            </h5>
                                            <TransferLiabilityContactDetails contact={transfer.liabilityPartyContact} />
                                        </div>
                                        <div className="col-12 mt-4">
                                            <div className="row mb-3">
                                                <div className="col-md-3 col-12 ">
                                                    <p className="font-weight-semi-bold  mb-1">Date Received:</p>
                                                </div>
                                                <div className='col-md-6 col-12'>
                                                    {toDateString(transfer.timestamp)}
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-md-3 col-12 ">
                                                    <p className="font-weight-semi-bold  mb-1">Reason:</p>
                                                </div>
                                                <div className='col-md-6 col-12'>
                                                    <div className="form-group">
                                                        <textarea required rows={8} className="form-control mb-0" type="text" value={response} onChange={e => {
                                                            setResponse(e.target.value)
                                                            formUtilities.requiredField(e.target.parentNode, e.target.value)
                                                        }} />
                                                        <small className='invalid-feedback text-danger'>Please specify a reason to accept/decline this transfer of liability.</small>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="card-footer border-top ">
                                    <div className="row justify-content-center">
                                        <div className="col-12 col-sm-auto ">
                                            <div id="dashboard-actions">
                                                <button type="button" className="btn btn-danger btn-sm ml-2" onClick={() => decline()}>
                                                    <i className="fas fa-times"></i> Decline</button>
                                                <button type="button" className="btn btn-success btn-sm ml-2" onClick={() => accept()}>
                                                    <i className="fas fa-check"></i> Accept</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>}
            {isNew && <>
                <div className="card my-3">
                    <div className="card-header themed-title">
                        <div className="row align-items-center justify-space-between">
                            <div className="col">
                                <h4 className="mb-0 ">
                                    Create Transfer of Liability Request
                                </h4>
                            </div>
                            <Link className="btn btn-falcon-default btn-sm mr-3 py-1" type="button" to={backUrl}><i className="fas fa-reply"></i> Back</Link>
                        </div>
                    </div>
                    <div className="card-body bg-light border-top">
                        <div className="row">
                            <div className="col-12">
                                <h5 className="mb-2">Notifier Details</h5>
                            </div>
                        </div>
                        {
                            !arrayUtilities.isNullOrEmpty(contacts) &&
                            <div className="row mb-3">
                                <div className="col-md-3 col-12 ">
                                    <p className="font-weight-semi-bold mb-1">Contact</p>
                                </div>
                                <div className="col-md-6 col-12">
                                    {
                                        contacts.map(
                                            contact => <div className='form-check mb-2'>
                                                <input className="form-check-input my-0" type="radio" name="contact-list-selection" id={ contact.id } checked={ selectedContact === contact.id } onClick={ () => handleContactSelection(contact.id) } />
                                                <label className={`form-check-label ml-3 mb-0${contact.isActive ? " font-weight-bold" : ""}`} htmlFor={ contact.id }>
                                                    {stringHelpers.contactDetailsName(contact)} {contact.isActive && <>(Active)</>}
                                                </label>
                                            </div>
                                        )
                                    }
                                    <div className='form-check mb-2'>
                                        <input class="form-check-input my-0" type="radio" name="contact-list-selection" id="manual-entry-selection" checked={ newContactMode } onClick={ () => {
                                            setNewContactMode(true)
                                            setSelectedContact(null)
                                            resetContactFields()
                                        } } />
                                        <label class="form-check-label ml-3 mb-0" for="manual-entry-selection">
                                            Create a new contact<i className='ml-1 fas fa-plus text-success'></i>
                                        </label>
                                    </div>
                                </div>
                            </div>
                        }
                        {
                            newContactMode &&
                            <>
                                <div className="row">
                                    <div className="col-md-3 col-12 ">
                                        <p className="font-weight-semi-bold mb-1">Title</p>
                                    </div>
                                    <div className="col-md-6 col-12 ">
                                        <div className="form-group mb-0">
                                            <div className="dropdown">
                                                <button className="btn btn-falcon-default dropdown-toggle btn-sm mb-1 edit-dropdown" id="select-title" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">{ title !== "" && <>{ title }</> }{ title === "" && <>Select Title</> }</button>
                                                <div className="dropdown-menu py-0 edit-dropdown" aria-labelledby="select-title" >
                                                    <div className="bg-white py-2 rounded-soft">
                                                        <button className="dropdown-item text-base px-3 py-2" onClick={ () => setTitle("Mr") }>Mr</button>
                                                        <button className="dropdown-item text-base px-3 py-2" onClick={ () => setTitle("Mrs") }>Mrs</button>
                                                        <button className="dropdown-item text-base px-3 py-2" onClick={ () => setTitle("Miss") }>Miss</button>
                                                        <button className="dropdown-item text-base px-3 py-2" onClick={ () => setTitle("Ms") }>Ms</button>
                                                        <button className="dropdown-item text-base px-3 py-2" onClick={ () => setTitle("Dr") }>Dr</button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-12 col-md-3">
                                        <p className="font-weight-semi-bold mt-1 mb-1">First Name</p>
                                    </div>
                                    <div className="col-12 col-md-6">
                                        <div className="form-group mb-1">
                                            <input className="form-control mb-0" type="text" value={ firstName } onChange={ (e) => setFirstName(e.target.value) } />
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-12 col-md-3">
                                        <p className="font-weight-semi-bold mt-1 mb-1">Last Name</p>
                                    </div>
                                    <div className="col-12 col-md-6">
                                        <div className="form-group mb-1">
                                            <input className="form-control mb-0" type="text" value={ lastName } onChange={ (e) => setLastName(e.target.value) } />
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-12 col-md-3">
                                        <p className="font-weight-semi-bold mt-1 mb-1">Company Name</p>
                                    </div>
                                    <div className="col-12 col-md-6">
                                        <div className="form-group mb-1">
                                            <input className="form-control mb-0" type="text" value={ companyName } onChange={ (e) => setCompanyName(e.target.value) } />
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-12 col-md-3">
                                        <p className="font-weight-semi-bold mt-1 mb-1">Address Line 1<span className="req"></span></p>
                                    </div>
                                    <div className="col-12 col-md-6">
                                        <div className="form-group mb-1">
                                            <input className="form-control mb-0" type="text" value={ address1 } onChange={ (e) => setAddress1(e.target.value) } />
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-12 col-md-3">
                                        <p className="font-weight-semi-bold mt-1 mb-1">Address Line 2</p>
                                    </div>
                                    <div className="col-12 col-md-6">
                                        <div className="form-group mb-1">
                                            <input className="form-control mb-0" type="text" value={ address2 } onChange={ (e) => setAddress2(e.target.value) } />
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-12 col-md-3">
                                        <p className="font-weight-semi-bold mt-1 mb-1">Address Line 3</p>
                                    </div>
                                    <div className="col-12 col-md-6">
                                        <div className="form-group mb-1">
                                            <input className="form-control mb-0" type="text" value={ address3 } onChange={ (e) => setAddress3(e.target.value) } />
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-12 col-md-3">
                                        <p className="font-weight-semi-bold mt-1 mb-1">City<span className="req"></span></p>
                                    </div>
                                    <div className="col-12 col-md-6">
                                        <div className="form-group mb-1">
                                            <input className="form-control mb-0" type="text" value={ city } onChange={ (e) => setCity(e.target.value) } />
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-12 col-md-3">
                                        <p className="font-weight-semi-bold mt-1 mb-1">Postcode<span className="req"></span></p>
                                    </div>
                                    <div className="col-12 col-md-6">
                                        <div className="form-group mb-1">
                                            <input className="form-control mb-0" type="text" value={ postcode } onChange={ (e) => setPostcode(e.target.value) } />
                                        </div>
                                    </div>
                                </div>
                                <div className="row mb-1">
                                    <div className="col-md-3 col-12 ">
                                        <p className="font-weight-semi-bold mb-1">Country</p>
                                    </div>
                                    <div className="col-md-6 col-12 ">
                                        <div className="form-group mb-0">
                                            <SearchSelect
                                                width="100%"
                                                options={ countries.map(item => ({ value: item.name, label: item.name })) }
                                                onSelect={ value => setCountry(value) }
                                                selected={ country }
                                                defaultLabel="Select country"
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-12 col-md-3">
                                        <p className="font-weight-semi-bold mt-1 mb-1">Contact Number</p>
                                    </div>
                                    <div className="col-12 col-md-6">
                                        <div className="form-group mb-1">
                                            <input className="form-control mb-0" type="text" value={ contactNumber } onChange={ (e) => setContactNumber(e.target.value) } />
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-12 col-md-3">
                                        <p className="font-weight-semi-bold mt-1 mb-1">Email Address<span className="req"></span></p>
                                    </div>
                                    <div className="col-12 col-md-6">
                                        <div className="form-group mb-1">
                                            <input className="form-control mb-0" type="text" value={ emailAddress } onChange={ (e) => setEmailAddress(e.target.value) } />
                                        </div>
                                    </div>
                                </div>
                            </>
                        }
                        <div className="row align-items-center">
                            <div className="col-12 col-md-3">
                                <p className="font-weight-semi-bold mt-1 mb-1">Supporting Document<span className="req"></span></p>
                            </div>
                            {fileNotifier !== null &&
                                <div className="col-12 col-md-6">
                                    <div className="row align-items-center">
                                        <div className="col-4">
                                            <a href={fileNotifier.url} target="_blank"><h6 className="m">{fileNotifier.filename}</h6></a>
                                        </div>
                                        <div className="col-5">
                                            {fileNotifier.isImage &&
                                                <div className="d-flex justify-content-center my-2">
                                                    <img src={fileNotifier.url} className="attachment-thumb" />
                                                </div>}
                                            {!fileNotifier.isImage && <>
                                                {fileNotifier.contentType === "application/pdf" && <div className="d-flex justify-content-center my-2"><i className="far fa-6x fa-file-pdf"></i></div>}
                                                {fileNotifier.contentType === "application/word.doc" && <div className="d-flex justify-content-center my-2"><i className="far fa-file-word"></i></div>}
                                                {fileNotifier.contentType !== "application/word.doc" && fileNotifier.contentType !== "application/pdf" && <div className="d-flex justify-content-center my-2"><i className="far fa-file-alt"></i></div>}
                                            </>}
                                        </div>
                                        <div className="col-3">
                                            <button className="btn btn-sm btn-danger" onClick={() => setFileNotifier(null)}>Remove</button>
                                        </div>
                                    </div>
                                </div>}
                            {fileNotifier === null &&
                                <div className="col-auto">
                                    <button className="btn btn-falcon-default mt-1" onClick={handleShowNotifier}>
                                        Add Supporting Document
                                    </button>
                                </div>}
                        </div>
                        <Modal show={showNotifier} onHide={handleCloseNotifier}>
                            <UploadFiles onSuccess={(file) => setFileNotifier(file)} type="Document" hideDone={true} organisationId={props.organisationId} />
                            <Modal.Footer>
                                <button className="btn btn-falcon-default mt-1" onClick={handleCloseNotifier}>
                                    Done
                                </button>
                            </Modal.Footer>
                        </Modal>
                        <hr className="border-dashed border-bottom-0"></hr>
                        <div className="row">
                            <div className="col-12">
                                <h5>Liable Party Details</h5>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-3 col-12">
                                <p className="font-weight-semi-bold mb-1">Liable Party Designation<span className="req"></span></p>
                            </div>
                            <div className="col-md-6 col-12 ">
                                {contactTypes !== null && contactTypes.map((item, i = 0) => {
                                    i++;
                                    var text = `The Liable party was/is the ` + item + ` of the vehicle`
                                    var checked = false;
                                    if (designationLiable === i - 1) {
                                        checked = true;
                                    }
                                    return (
                                        <div class="form-check mb-2">
                                            <input class="form-check-input my-0" type="radio" name="flexRadioDefault" id={i} checked={checked} onClick={() => setDesignationLiable(i - 1)} />
                                            <label class="form-check-label ml-3 mb-0" for={i}>
                                                {text}
                                            </label>
                                        </div>
                                    )
                                })}
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-3 col-12 ">
                                <p className="font-weight-semi-bold mb-1">Title</p>
                            </div>
                            <div className="col-md-6 col-12 ">
                                <div className="form-group mb-0">
                                    <div className="dropdown">
                                        <button className="btn btn-falcon-default dropdown-toggle btn-sm mb-1 edit-dropdown" id="select-title" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">{titleLiable !== "" && <>{titleLiable}</>}{titleLiable === "" && <>Select Title</>}</button>
                                        <div className="dropdown-menu py-0 edit-dropdown" aria-labelledby="select-title" >
                                            <div className="bg-white py-2 rounded-soft">
                                                <button className="dropdown-item text-base px-3 py-2" onClick={() => setTitleLiable("Mr")}>Mr</button>
                                                <button className="dropdown-item text-base px-3 py-2" onClick={() => setTitleLiable("Mrs")}>Mrs</button>
                                                <button className="dropdown-item text-base px-3 py-2" onClick={() => setTitleLiable("Miss")}>Miss</button>
                                                <button className="dropdown-item text-base px-3 py-2" onClick={() => setTitleLiable("Ms")}>Ms</button>
                                                <button className="dropdown-item text-base px-3 py-2" onClick={() => setTitleLiable("Dr")}>Dr</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-12 col-md-3">
                                <p className="font-weight-semi-bold mt-1 mb-1">First Name</p>
                            </div>
                            <div className="col-12 col-md-6">
                                <div className="form-group mb-1">
                                    <input className="form-control mb-0" type="text" value={firstNameLiable} onChange={(e) => setFirstNameLiable(e.target.value)} />
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-12 col-md-3">
                                <p className="font-weight-semi-bold mt-1 mb-1">Last Name</p>
                            </div>
                            <div className="col-12 col-md-6">
                                <div className="form-group mb-1">
                                    <input className="form-control mb-0" type="text" value={lastNameLiable} onChange={(e) => setLastNameLiable(e.target.value)} />
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-12 col-md-3">
                                <p className="font-weight-semi-bold mt-1 mb-1">Company Name</p>
                            </div>
                            <div className="col-12 col-md-6">
                                <div className="form-group mb-1">
                                    <input className="form-control mb-0" type="text" value={companyNameLiable} onChange={(e) => setCompanyNameLiable(e.target.value)} />
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-12 col-md-3">
                                <p className="font-weight-semi-bold mt-1 mb-1">Address Line 1<span className="req"></span></p>
                            </div>
                            <div className="col-12 col-md-6">
                                <div className="form-group mb-1">
                                    <input className="form-control mb-0" type="text" value={address1Liable} onChange={(e) => setAddress1Liable(e.target.value)} />
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-12 col-md-3">
                                <p className="font-weight-semi-bold mt-1 mb-1">Address Line 2</p>
                            </div>
                            <div className="col-12 col-md-6">
                                <div className="form-group mb-1">
                                    <input className="form-control mb-0" type="text" value={address2Liable} onChange={(e) => setAddress2Liable(e.target.value)} />
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-12 col-md-3">
                                <p className="font-weight-semi-bold mt-1 mb-1">Address Line 3</p>
                            </div>
                            <div className="col-12 col-md-6">
                                <div className="form-group mb-1">
                                    <input className="form-control mb-0" type="text" value={address3Liable} onChange={(e) => setAddress3Liable(e.target.value)} />
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-12 col-md-3">
                                <p className="font-weight-semi-bold mt-1 mb-1">City<span className="req"></span></p>
                            </div>
                            <div className="col-12 col-md-6">
                                <div className="form-group mb-1">
                                    <input className="form-control mb-0" type="text" value={cityLiable} onChange={(e) => setCityLiable(e.target.value)} />
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-12 col-md-3">
                                <p className="font-weight-semi-bold mt-1 mb-1">Postcode<span className="req"></span></p>
                            </div>
                            <div className="col-12 col-md-6">
                                <div className="form-group mb-1">
                                    <input className="form-control mb-0" type="text" value={postcodeLiable} onChange={(e) => setPostcodeLiable(e.target.value)} />
                                </div>
                            </div>
                        </div>
                        <div className="row mb-1">
                            <div className="col-md-3 col-12 ">
                                <p className="font-weight-semi-bold mb-1">Country</p>
                            </div>
                            <div className="col-md-6 col-12 ">
                                <div className="form-group mb-0">
                                    <SearchSelect
                                        width="100%"
                                        options={ countries.map(item => ({ value: item.name, label: item.name })) }
                                        onSelect={ value => setCountryLiable(value) }
                                        selected={ countryLiable }
                                        defaultLabel="Select country"
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-12 col-md-3">
                                <p className="font-weight-semi-bold mt-1 mb-1">Contact Number</p>
                            </div>
                            <div className="col-12 col-md-6">
                                <div className="form-group mb-1">
                                    <input className="form-control mb-0" type="text" value={contactNumberLiable} onChange={(e) => setContactNumberLiable(e.target.value)} />
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-12 col-md-3">
                                <p className="font-weight-semi-bold mt-1 mb-1">Email Address<span className="req"></span></p>
                            </div>
                            <div className="col-12 col-md-6">
                                <div className="form-group mb-1">
                                    <input className="form-control mb-0" type="text" value={emailAddressLiable} onChange={(e) => setEmailAddressLiable(e.target.value)} />
                                </div>
                            </div>
                        </div>
                        <div className="row align-items-center">
                            <div className="col-12 col-md-3">
                                <p className="font-weight-semi-bold mt-1 mb-1">Supporting Document<span className="req"></span></p>
                            </div>
                            {fileLiable !== null &&
                                <div className="col-12 col-md-6">
                                    <div className="row align-items-center">
                                        <div className="col-4">
                                            <a href={fileLiable.url} target="_blank"><h6 className="m">{fileLiable.filename}</h6></a>
                                        </div>
                                        <div className="col-5">
                                            {fileLiable.isImage &&
                                                <div className="d-flex justify-content-center my-2">
                                                    <img src={fileLiable.url} className="attachment-thumb" />
                                                </div>}
                                            {!fileLiable.isImage && <>
                                                {fileLiable.contentType === "application/pdf" && <div className="d-flex justify-content-center my-2"><i className="far fa-6x fa-file-pdf"></i></div>}
                                                {fileLiable.contentType === "application/word.doc" && <div className="d-flex justify-content-center my-2"><i className="far fa-file-word"></i></div>}
                                                {fileLiable.contentType !== "application/word.doc" && fileLiable.contentType !== "application/pdf" && <div className="d-flex justify-content-center my-2"><i className="far fa-file-alt"></i></div>}
                                            </>}
                                        </div>
                                        <div className="col-3">
                                            <button className="btn btn-sm btn-danger" onClick={() => setFileLiable(null)}>Remove</button>
                                        </div>
                                    </div>
                                </div>}
                            {fileLiable === null &&
                                <div className="col-auto">
                                    <button className="btn btn-falcon-default mt-1" onClick={handleShowLiable}>
                                        Add Supporting Document
                                    </button>
                                </div>}
                        </div>
                        <hr className="border-dashed border-bottom-0"></hr>
                        <div className="row">
                            <div className="col-12 col-md-3">
                                <p className="font-weight-semi-bold mt-1 mb-1">Date Received</p>
                            </div>
                            <div className="col-12 col-md-6">
                                <div className="form-group mb-0">
                                    <input className="form-control mb-1" type="date" value={ toInputFieldDateString(dateReceived) } onChange={ (e) => setDateReceived(e.target.value) } />
                                </div>
                            </div>
                        </div>
                        <Modal show={showLiable} onHide={handleCloseLiable}>
                            <UploadFiles onSuccess={(file) => setFileLiable(file)} type="Document" hideDone={true} organisationId={props.organisationId} />
                            <Modal.Footer>
                                <button className="btn btn-falcon-default mt-1" onClick={handleCloseLiable}>
                                    Done
                                </button>
                            </Modal.Footer>
                        </Modal>
                    </div>
                    <div className="card-footer border-top">
                        <div className="row client-edit-buttons">
                            <div className="col-6 col-sm-auto ml-auto  pl-0">
                                <div id="dashboard-actions">
                                    <Link className="btn btn-falcon-default btn-sm" to={backUrl}><i className="fas fa-times"></i> Cancel</Link>
                                    <button type="button" className="btn btn-success btn-sm ml-2" disabled={false} onClick={() => submit()}>
                                        <i className="fas fa-check"></i> Confirm</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>}
            {!stringHelpers.isNullOrEmpty(errorMessage) && <ErrorModal message={errorMessage} onHide={() => setErrorMessage(null)} />}
        </>
    )
}
export default TransferLiability;